import { motion } from "framer-motion";
import kowokLogo from "@/assets/clients/kowok.png";
import kawokLogo from "@/assets/clients/kawok.png";
import bbqWokLogo from "@/assets/clients/bbq-wok-final.png";
import indiThaiLogo from "@/assets/clients/indi-thai.png";
import thaiBreakLogo from "@/assets/clients/thai-break.png";
import makanKafeLogo from "@/assets/clients/makan-kafe-clean.png";

interface Client {
  name: string;
  logo: string;
}

const clients: Client[] = [
  { name: "Kowok", logo: kowokLogo },
  { name: "Kawok", logo: kawokLogo },
  { name: "BBQ Wok", logo: bbqWokLogo },
  { name: "Indi Thai", logo: indiThaiLogo },
  { name: "Thaï Break", logo: thaiBreakLogo },
  { name: "Makan Kafé", logo: makanKafeLogo },
];

const ClientsSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-background via-secondary/20 to-background">
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Ils nous font confiance
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4">
            Nos Clients
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mb-6" />
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Des restaurateurs passionnés qui nous font confiance pour leurs emballages durables et personnalisés.
          </p>
        </motion.div>

        {/* Clients Grid */}
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
            {clients.map((client, index) => (
              <motion.div
                key={client.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-background/80 backdrop-blur-sm rounded-xl p-6 flex items-center justify-center aspect-square shadow-soft hover:shadow-lg transition-all duration-300 hover:scale-105 border border-border/50"
              >
                <img
                  src={client.logo}
                  alt={`Logo ${client.name}`}
                  className="max-w-[85%] max-h-[85%] object-contain filter grayscale hover:grayscale-0 transition-all duration-500"
                />
              </motion.div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ClientsSection;
